// @flow
import styled from 'styled-components';

export const Heading = styled.h2`
    border-bottom: 1px solid ${props => props.theme.mediumGrey};
    padding-bottom: 0.5em;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/filter/header/styles.js